import { Linkedin } from "lucide-react";
import { useLang, scrollTo } from "@/App";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-inkdeep px-5 md:px-10 pt-20 pb-10">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-10 pb-14 border-b border-linedark">
          <div>
            <p className="font-display text-3xl md:text-4xl text-paper leading-tight">
              Gilles <span className="italic text-terraBright">de Buretel</span> de Chassey
            </p>
            <p data-testid="footer-tagline" className="font-display italic text-lg text-gold/80 mt-3">{t.footer.tagline}</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 items-start content-start">
            {[
              ["biographie", t.nav.bio],
              ["activites", t.nav.activities],
              ["livre", t.nav.book],
              ["sculptures", t.nav.sculptures],
              ["publications", t.nav.publications],
              ["inventions", t.nav.inventor],
              ["fetes", t.nav.fetes],
              ["contact", t.nav.contact],
            ].map(([id, label]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollTo(id)}
                className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-paper/50 hover:text-gold transition-colors link-underline"
              >
                {label}
              </button>
            ))}
          </nav>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p data-testid="footer-rights" className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-paper/35">{t.footer.rights}</p>
          <div className="flex items-center gap-5">
            <a data-testid="footer-linkedin-link" href="https://www.linkedin.com/in/gdechassey" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-paper/35 hover:text-gold transition-colors">
              <Linkedin size={15} />
            </a>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-paper/35">Vains — 50300 — Baie du Mont-Saint-Michel</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
